function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.66536 4.0013C4.66536 2.16035 6.15775 0.667969 7.9987 0.667969C9.83965 0.667969 11.332 2.16035 11.332 4.0013C11.332 5.84225 9.83965 7.33464 7.9987 7.33464C6.15775 7.33464 4.66536 5.84225 4.66536 4.0013ZM7.9987 2.0013C6.89413 2.0013 5.9987 2.89673 5.9987 4.0013C5.9987 5.10587 6.89413 6.0013 7.9987 6.0013C9.10327 6.0013 9.9987 5.10587 9.9987 4.0013C9.9987 2.89673 9.10327 2.0013 7.9987 2.0013Z",
  fill: "#1E40AD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.70663 14.0013C3.03469 11.3704 5.27895 9.8348 7.9987 9.8348C9.52324 9.8348 10.8975 10.4736 11.8703 11.5L12.3289 11.9839L13.2967 11.0667L12.8381 10.5828C11.6239 9.3018 9.90423 8.50146 7.9987 8.50146C4.3168 8.50146 1.33203 10.9861 1.33203 14.668V15.3346H9.02187V14.0013H2.70663Z",
  fill: "#1E40AD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6082 12.0013L11.9987 15.6108L9.72256 13.3346L10.6654 12.3918L11.9987 13.7252L14.6654 11.0585L15.6082 12.0013Z",
  fill: "#1E40AD"
});

function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.246c6f75.svg";
export { ForwardRef as ReactComponent };